// This enum should be align with the `StreamSymbol` in the PLT_backend:
// https://code.netbase.com/netbasequid/PLT_backend/blob/master/prospero-api/src/main/java/com/accelovation/prospero/api/data/ProsperoConstants.java

const StreamSymbol = Object.freeze({
  ELSSD: 'ELSSD',
  ELSSR: 'ELSSR',
  ELSSP: 'ELSSP',
  ELS36: 'ELS36',
  ELSBK: 'ELSBK',
  ELSEC: 'ELSEC',
  ELSMR: 'ELSMR',
  ELSEM: 'ELSEM',
  OVDJN: 'OVDJN',
  OVDBK: 'OVDBK',
  PUBMD: 'PUBMD',
  WKPAR: 'WKPAR',
  NBSDC: 'NBSDC',
  NBSPD: 'NBSPD',
  SPNPM: 'SPNPM',
  SPNP2: 'SPNP2',
  SPNCM: 'SPNCM',
  SPSPM: 'SPSPM',
  SPSCM: 'SPSCM',
  BRDFR: 'BRDFR',
  BRDF2: 'BRDF2',
  BRDRV: 'BRDRV',
  BRDBL: 'BRDBL',
  BRDCM: 'BRDCM',
  BRDNW: 'BRDNW',
  TWTTR: 'TWTTR',
  GNPAS: 'GNPAS',
  GNPPT: 'GNPPT',
  USPTM: 'USPTM',
  DTCPD: 'DTCPD',
  DSFTW: 'DSFTW',
  CBANW: 'CBANW',
  BUZFR: 'BUZFR',
  BUZRV: 'BUZRV',
  DQSCM: 'DQSCM',
  FHGNIP: 'FHGNIP',
  DHGNIP: 'DHGNIP',
  NETBASE: 'NETBASE',
  FHDATASIFT: 'FHDATASIFT',
  DCIGNIP: 'DCIGNIP',
  DCIDATASIFT: 'DCIDATASIFT',
  DCIFACEBOOK: 'DCIFACEBOOK',
  BRDSR: 'BRDSR',
  BRDTW: 'BRDTW',
  BRDWS: 'BRDWS',
  BRDWC: 'BRDWC',
  GNPVK: 'GNPVK',
  SPNPMNOD: 'SPNPMNOD',
  GNPHP: 'GNPHP',
  NBRCD: 'NBRCD',
  DSFTH: 'DSFTH',
  TBLFH: 'TBLFH',
  INSTAG: 'INSTAG',
  FPPS: 'FPPS',
  TCBINT: 'TCBINT',
  SPNRJ: 'SPNRJ',
  YOUTUBE: 'YOUTUBE',
  GNPDH: 'GNPDH',
  GNPDHCV: 'GNPDHCV',
  GNPFHCV: 'GNPFHCV',
  VOC: 'VOC',
  BUZNW: 'BUZNW',
  BUZBL: 'BUZBL',
  TWINGLY: 'TWINGLY',
  INSTAGCV: 'INSTAGCV',
  VK: 'VK',
  BRDRDT: 'BRDRDT',
  FACEBOOKCV: 'FACEBOOKCV',
  INSTAG2: 'INSTAG2',
  INSTAG2CV: 'INSTAG2CV',
  BRDRDT2: 'BRDRDT2',
  LXNX: 'LXNX',
  WEIBO: 'WEIBO',
  TIKTOK: 'TIKTOK',
  TWINGLYFR: 'TWINGLYFR',
  GNPFH2: 'GNPFH2',
  GNPDH2: 'GNPDH2',
  GNPFH2CV: 'GNPFH2CV',
  GNPDH2CV: 'GNPDH2CV',
  XDH2: 'XDH2',
  XFH2: 'XFH2',
  XHFH2: 'XHFH2',
  XDH2CV: 'XDH2CV',
  XFH2CV: 'XFH2CV',
  BLUESKY: 'BLUESKY',
  LXNXBRDCST: 'LXNXBRDCST',
  PODCAST: 'PODCAST'
})
export default StreamSymbol
export type StreamSymbolStrings = typeof StreamSymbol[keyof typeof StreamSymbol]
// RESERVE BELOW
